import slugify from 'slugify'
import { bsConstants } from '../../module.constants'

export const getBillingPlan = (authorRole?: string) => {
  const { ...roles } = bsConstants.USER.ROLES.AUTHOR
  switch (authorRole) {
    case roles.FREE: return 'Free Plan'
    case roles.GROWING: return 'Growing Author'
    case roles.PRO: return 'Pro Author'
    case roles.BEST_SELLING: return 'Bestselling Author'
    case roles.PUBLISHER: return 'Publisher or ARC Service'
    default: return ''
  }
}

export const getStripeUrl = (stripeCustomerId?: string) => {
  return stripeCustomerId ? `https://dashboard.stripe.com/customers/${stripeCustomerId}` : ''
}

export const getAdminUrl = (userId: number, userName?: string) => {
  // userName should be their name or email
  const name = slugify(userName + '', {
    strict: true
  })

  return `https://booksprout.co/admin/user/${userId}/${name}`
}
